import { render, staticRenderFns } from "./DemoRequestsList.vue?vue&type=template&id=fdc8ca54&"
import script from "./DemoRequestsList.vue?vue&type=script&lang=js&"
export * from "./DemoRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports